document.addEventListener('DOMContentLoaded', function () {
    const heroSwiper = new Swiper('.c-featured-swiper', {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
            el: '.swiper-pagination-featured',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            640: {
                slidesPerView: 1
            }
        }
      });
});